export default __webpack_public_path__ + "static/media/gallery7.c2f27826.jpg";